<template>
  <div class="share-page">
    <div class="banner">
      <!-- <picture>
        <source media="(max-width: 992px )" srcset="../Home/images/01841_03_mobile.png">
        <img class="img-responsive" src="../Home/images/01841_03.png" alt />
      </picture> -->
      <Banner loc="6" />
    </div>
    <CaptionBar :title="$t('share.caption')" subTitle="BLOG SHARE" />
    <div class="top-share c-layout">
      <router-link
        :to="{name:'shareDetail',query:{id:topItem.id}}"
        class="share-item item-block"
      >
      <!-- <div class="item-block"> -->
        <div class="img img-block">
          <img class="img-responsive" :src="topItem.photo" :alt="topItem.name" />
        </div>
        <div class="desc detail-block">
          <div class="date"><span class="date-content">{{ moment(topItem.publishdate).format("MMM DD ddd YYYY") }}</span><span class="ceate-name">By mtBRA</span></div>
          <p class="title">{{topItem.name}}</p>
          <p class="content">{{topItem.conent}}</p>
          <div class="desc-bottom">
            <span>{{topItem.createName}}</span>
            <!-- <router-link  target="_blank" class="btn btn-outline-white" :to="{name:'shareDetail',query:{id:topItem.id}}">查看更多</router-link> -->
          </div>
        </div>
      <!-- </div> -->
      </router-link>
    </div>
    <div class="share-list c-layout" v-if="list" v-loading="loading">
      <router-link
        :to="{name:'shareDetail',query:{id:item.id}}"
        class="share-item item-block"
        v-for="(item,index) in list"
        :key="index"
      >
        <div class="img-block">
          <img :src="item.photo" alt />
        </div>
        <div class="detail-block">
          <p class="date show-on-pad-flex"><span class="date-content">{{moment(topItem.publishdate).format("MMM DD ddd YYYY")}}</span><span class="ceate-name">By mtBRA</span></p>
          <span class="title">{{item.name}}</span>
          <p class="content">{{item.content}}</p>
          <div class="share-item__bottom hide-on-pad">
            <p class="date"><span class="date-content">{{moment(item.publishdate).format("YYYY.MM.DD")}}</span><span class="ceate-name">By mtBRA</span></p>
            <p>{{item.createName}}</p>
          </div>
          <!-- <router-link  target="_blank" class="btn btn-outline-white show-on-pad-flex" :to="{name:'shareDetail',query:{id:topItem.id}}">查看更多</router-link> -->
        </div>
      </router-link>
    </div>
    <!-- <Pagination
      v-if="list"
      :total="total"
      :page-size="pageSize"
      :current-page="currentPage"
      @handleCurrentChange="handleCurrentChange"
      @handlePageIndex="handlePageIndex"
    /> -->
    <Pagination
      v-if="list"
      :pageSize="pageSize"
      :pages="currentPage"
      :total="total"
      :listLoading="loading"
      @handelPaginationChange="handleCurrentChange"
    />
  </div>
</template>

<script>
import Banner from "@/components/Banner";
import CaptionBar from "@/components/CaptionBar";
// import Pagination from "@/components/Pagination/";
import Pagination from '@/components/Pagination/NewPagination.vue';
import { getShareList } from "@/api";
import moment from "moment";

export default {
  data() {
    return {
      loading: false,
      total: 0,
      currentPage: 1,
      pageSize: 10, //每页显示多少条
      list: "",
      topItem: "",
    };
  },
  async mounted() {
    this.getList({ page: this.currentPage, count: this.pageSize });
  },
  methods: {
    moment,
    handlePageIndex(val) {
      this.currentPage = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList({ page: val, count: this.pageSize });
    },
    async getList(data) {
      this.loading = true;
      let res = await getShareList(data);
      this.list = res.share.data;
      this.topItem = this.list.splice(0, 1)[0];
      this.total = res.share.total;
      this.loading = false;
    },
  },
  components: {
    CaptionBar,
    Pagination,
    Banner
  },
};
</script>

<style  lang='less'>
.share-page {
  a {
    text-decoration: none;
  }
  .banner {
    // height: 675px;
  }
  .caption-bar-comp {
    transform: translateY(-27px);
    .caption-line {
      width: 100%;
    }
    @media (max-width: 992px) {
      transform: translateY(-13px);
    }
  }
  .top-share {
    padding-bottom: 48px;
    padding-top: 15px;
    display: flex;
    .item-block {
      display: flex;
      width: 100%;
    }
    .img{
      width: 540px;
      height: 350px;
      flex-shrink: 0;
    }
    .desc {
      position: relative;
      margin-left: 30px;
      width: 100%;
      .date {
        margin-bottom: 15px;

        font-size: 16px;
        line-height: 24px;
        color: var(---unnamed-color-707070);
      }
      .title {
        font-size: 32px;
        line-height: 47px;
        font-weight: 500;
        color: var(--unnamed-color-111111);
        margin-bottom: 15px;
      }
      .content {
        padding-bottom: 10px;

        font-size: 16px;
        line-height: 24px;

        color: var(---unnamed-color-707070);
      }
      .desc-bottom {
        position: absolute;
        display: flex;
        width: 100%;
        justify-content: space-between;
        bottom: 0;
        left: 0;

        font-size: 16px;
        line-height: 24px;
        color: var(--unnamed-color-111111);

        .btn {
          
          cursor: pointer;
          width: 125px;
          height: 40px;

          font-size: 16px;
          line-height: 24px;
          color: var(--unnamed-color-111111);
          border: 1px solid var(--unnamed-color-111111);
        }
      }
    }
  }

  .share-list {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 25px;
    // min-height: 500px;
    .share-item:nth-child(3n) {
      margin-right: 0px;
    }
    .share-item {
      cursor: pointer;
      width: 350px;
      margin-bottom: 32px;
      display: flex;
      flex-direction: column;
      margin-right: 30px;
      font-weight: 500;
      img {
        width: 100%;
        height: 200px;
        object-fit: cover;
      }
      .title {
        /*! autoprefixer: ignore next */
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;

        font-size: 16px;
        line-height: 24px;
        color: var(---unnamed-color-707070);
        padding: 16px 0;
      }
      .content {
        min-height: 36px;
        margin-bottom: 21px;
        font-size: 12px;
        line-height: 18px;
        color: var(---unnamed-color-707070);
        /*! autoprefixer: ignore next */
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
      }
      .share-item__bottom {
        display: flex;
        justify-content: space-between;

        font-size: 16px;
        line-height: 24px;
        color: var(---unnamed-color-707070);

        p {
          font-size: 16px;
          line-height: 24px;

          color: var(--unnamed-color-111111);
        }
      }
    }
  }
  .date {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .pagination-comp {
    margin-bottom: 45px;
  }
  @media (max-width: 992px) {
    padding: 0 20px;
    .breadcrumbs {
      display: none;
    }
    .s-g-title {
      padding-top: 20px;
      padding-bottom: 20px;
    }
    .banner {
      width: calc(100% + 40px);
      margin-left: -20px;
      // height: 455px;
      img {
        display: block;
      }
    }
    .caption-bar-comp {
      width: calc(100% + 40px);
      margin-left: -20px;
      transform: translateY(-13px);
    }
    .share-list,.top-share {
      .img {
        // position: absolute;
        // top: 0%;
        // left: 0;
        // width: 100%;
        height: unset;
        // display: block;
      }
      .item-block {
        display: flex;
        flex-direction: column;
        margin-right: 0;
        .img-block {
          border: 1px solid black;
          margin-bottom: 8px;
          width: 100%;
          // height: calc(100%/350*200);
          padding-top: calc(100%/350*200);
          position: relative;
          overflow: hidden;
          img {
            position: absolute;
            top: 0%;
            left: 0;
            width: 100%;
            height: 100%;
            display: block;
          }
        }
        .detail-block {
          margin-left: 0;
          .date {
            font-size: 1rem;
            color: black;
            font-weight: 400;
            margin-bottom: 10px;
            span {
              transform: scale(.8);
              &:nth-child(1) {
                transform-origin: 0% 0%;
              }
              &:nth-last-child(1) {
                transform-origin: 100% 0%;
              }
            }
          }
          .title {
            font-size: 1.3rem;
            line-height: 1.3rem;
            margin: 0;
            margin-bottom: 10px;
            color: black;
          }
          .content {
            margin: 0;
            margin-bottom: 10px;
            color: #707070;
          }
          .btn-outline-white {
            position: relative;
            width: 146px;
            padding: 10px 0;
            font-size: 1rem;
            line-height: 1rem;
            height: auto;
            margin: auto;
          }
        }
      }
    }
  }
}
</style>
